/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThanksRouteImport } from './routes/thanks'
import { Route as FormRouteImport } from './routes/form'
import { Route as IndexRouteImport } from './routes/index'

const ThanksRoute = ThanksRouteImport.update({
  id: '/thanks',
  path: '/thanks',
  getParentRoute: () => rootRouteImport,
} as any)
const FormRoute = FormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/form': typeof FormRoute
  '/thanks': typeof ThanksRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/form': typeof FormRoute
  '/thanks': typeof ThanksRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/form': typeof FormRoute
  '/thanks': typeof ThanksRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/form' | '/thanks'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/form' | '/thanks'
  id: '__root__' | '/' | '/form' | '/thanks'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FormRoute: typeof FormRoute
  ThanksRoute: typeof ThanksRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/thanks': {
      id: '/thanks'
      path: '/thanks'
      fullPath: '/thanks'
      preLoaderRoute: typeof ThanksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form': {
      id: '/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof FormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FormRoute: FormRoute,
  ThanksRoute: ThanksRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
